module.exports = __webpack_public_path__ + "img/11.8d7ef854.svg";